<nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom" aria-label="Primary navigation">
  <div class="container">
    <a class="navbar-brand d-flex align-items-center" routerLink="/home" (click)="closeMenu()" aria-label="Upcoming Cars home">
      <span class="brand-mark" aria-hidden="true"><i class="fas fa-car"></i></span>
      <span class="fw-bold">Upcoming <span class="text-primary">Cars</span></span>
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen" aria-controls="mainNav" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="mainNav" [class.show]="isMenuOpen">
      <ul class="navbar-nav me-auto">
        <li class="nav-item"><a class="nav-link" routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMenu()">Home</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/about" routerLinkActive="active" (click)="closeMenu()">About Us</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/addcar" routerLinkActive="active" (click)="closeMenu()">Cars</a></li>
        <li class="nav-item"><a class="nav-link" routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">Contact Us</a></li>
        <li class="nav-item nav-demo"><a class="nav-link" href="mailto:piyushanandbang@gmail.com?subject=Upcoming%20Cars%20Inquiry" (click)="closeMenu()">Contact Us</a></li>
      </ul>

      <form class="nav-search d-flex me-3" role="search" (submit)="$event.preventDefault()" aria-label="Search Upcoming Cars content">
        <i class="fas fa-search" aria-hidden="true"></i>
        <input class="form-control form-control-sm" type="search" placeholder="Search cars..." aria-label="Search cars">
      </form>

      <ul class="navbar-nav account-nav">
        <li class="nav-item" *ngIf="!isLoggedIn"><a class="nav-link" routerLink="/login" routerLinkActive="active" (click)="closeMenu()">Log in</a></li>
        <li class="nav-item" *ngIf="!isLoggedIn"><a class="nav-link sign-up-link" routerLink="/registration" routerLinkActive="active" (click)="closeMenu()">Sign Up</a></li>

        <li class="nav-item dropdown" *ngIf="isLoggedIn">
          <a class="nav-link position-relative dropdown-toggle" href="#" id="notifMenu" role="button" data-bs-toggle="dropdown" aria-expanded="false" aria-label="Notifications">
            <i class="fas fa-bell"></i>
            <span *ngIf="notifications?.length>0" class="badge bg-danger rounded-pill ms-1">{{ notifications.length }}</span>
          </a>
          <ul class="dropdown-menu dropdown-menu-end p-2" aria-labelledby="notifMenu" style="min-width:320px;">
            <ng-container *ngIf="notifications && notifications.length>0; else none">
              <li>
                <div class="d-flex justify-content-between align-items-center px-2">
                  <strong>Notifications</strong>
                  <button class="btn btn-sm btn-link" (click)="clearNotifications()">Clear</button>
                </div>
              </li>
              <li><div class="dropdown-divider"></div></li>
              <li *ngFor="let n of notifications | slice:0:5">
                <button class="dropdown-item small text-start" type="button">
                  <div class="d-flex justify-content-between">
                    <div class="me-2">
                      <div class="fw-bold">{{ n.title || 'Notification' }}</div>
                      <div class="text-muted small text-truncate">{{ n.body }}</div>
                    </div>
                    <div class="text-muted small ms-2">{{ n.time | date:'shortTime' }}</div>
                  </div>
                </button>
              </li>
              <li><div class="dropdown-divider"></div></li>
              <li><a class="dropdown-item text-center small" routerLink="/notification" (click)="closeMenu()">View all</a></li>
            </ng-container>
            <ng-template #none>
              <li><div class="px-3 py-2 text-muted small">No notifications</div></li>
            </ng-template>
          </ul>
        </li>

        <li class="nav-item dropdown" *ngIf="isLoggedIn">
          <a class="nav-link dropdown-toggle" href="#" id="userMenu" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="fas fa-user-circle"></i> Account
          </a>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userMenu">
            <li><a class="dropdown-item" routerLink="/user-profile" (click)="closeMenu()">Profile</a></li>
            <li><a class="dropdown-item" routerLink="/table-list" (click)="closeMenu()">My Cars</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><button class="dropdown-item" (click)="logout()">Logout</button></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="successMsg" class="alert alert-success alert-dismissible fade show m-3" role="status">
    {{ successMsg }}
    <button type="button" class="btn-close" aria-label="Close" (click)="successMsg = ''"></button>
  </div>
</nav>
